const textToBold = (ace) => {
    var selectedrange = ace.current.editor.getSelectionRange();
    let selectedtext = ace.current.editor.getSelectedText();

    ace.current.editor.session.replace(
        selectedrange,
        "\\textbf{" + selectedtext + "}"
    );
};
const textToItalics = (ace) => {
    var selectedrange = ace.current.editor.getSelectionRange();
    let selectedtext = ace.current.editor.getSelectedText();

    ace.current.editor.session.replace(
        selectedrange,
        "\\textit{" + selectedtext + "}"
    );
};
const hbox = (ace) => {
    var selectedrange = ace.current.editor.getSelectionRange();
    let selectedtext = ace.current.editor.getSelectedText();
    ace.current.editor.session.replace(
        selectedrange,
        "\\hbox{" + selectedtext + "}"
    );
};
const allowdisplaybreaks  = (ace) => {
    var selectedrange = ace.current.editor.getSelectionRange();
    let selectedtext = ace.current.editor.getSelectedText();
    ace.current.editor.session.replace(
        selectedrange,
        "\\allowdisplaybreaks"+selectedtext
    );
};
const clearpage  = (ace) => {
    var selectedrange = ace.current.editor.getSelectionRange();
    let selectedtext = ace.current.editor.getSelectedText();

    ace.current.editor.session.replace(
        selectedrange,
        "\\clearpage{" + selectedtext + "}"
    );
};
const pagebreak  = (ace) => {
    var selectedrange = ace.current.editor.getSelectionRange();
    let selectedtext = ace.current.editor.getSelectedText();

    ace.current.editor.session.replace(
        selectedrange,
        "\\pagebreak{" + selectedtext + "}"
    );
};

const Query  = (ace) => {
    var selectedrange = ace.current.editor.getSelectionRange();
    let selectedtext = ace.current.editor.getSelectedText();

    ace.current.editor.session.replace(
        selectedrange,
        "\\Query{" + selectedtext + "}{}"
    );
};

const AQ  = (ace) => {
    var selectedrange = ace.current.editor.getSelectionRange();
    let selectedtext = ace.current.editor.getSelectedText();

    ace.current.editor.session.replace(
        selectedrange,
        "\\AQ{" + selectedtext + "}"
    );
};
const hspace  = (ace) => {
    var selectedrange = ace.current.editor.getSelectionRange();
    let selectedtext = ace.current.editor.getSelectedText();

    ace.current.editor.session.replace(
        selectedrange,
        "\\hspace*{" + selectedtext + "}"
    );
};
const vspace  = (ace) => {
    var selectedrange = ace.current.editor.getSelectionRange();
    let selectedtext = ace.current.editor.getSelectedText();

    ace.current.editor.session.replace(
        selectedrange,
        "\\vspace*{" + selectedtext + "}"
    );
};
const midrule  = (ace) => {
    var selectedrange = ace.current.editor.getSelectionRange();
    let selectedtext = ace.current.editor.getSelectedText();

    ace.current.editor.session.replace(
        selectedrange,
        // "\\midrule{" + selectedtext + "}"
        "\\midrule"+selectedtext
    );
};
const cmidrule  = (ace) => {
    var selectedrange = ace.current.editor.getSelectionRange();
    let selectedtext = ace.current.editor.getSelectedText();

    ace.current.editor.session.replace(
        selectedrange,
        "\\cmidrule{" + selectedtext + "}"
    );
};
const chaptermark  = (ace) => {
    var selectedrange = ace.current.editor.getSelectionRange();
    let selectedtext = ace.current.editor.getSelectedText();

    ace.current.editor.session.replace(
        selectedrange,
        "\\chaptermark{" + selectedtext + "}"
    );
};
const setcounter  = (ace) => {
    var selectedrange = ace.current.editor.getSelectionRange();
    let selectedtext = ace.current.editor.getSelectedText();

    ace.current.editor.session.replace(
        selectedrange,
        "\\setcounter{}{"+ selectedtext+"}"
    );
};
const setconter  = (ace) => {
    var selectedrange = ace.current.editor.getSelectionRange();
    let selectedtext = ace.current.editor.getSelectedText();

    ace.current.editor.session.replace(
        selectedrange,
        "\\setconter{}{"+ selectedtext+"}"
    );
};
const pagestyle  = (ace) => {
    var selectedrange = ace.current.editor.getSelectionRange();
    let selectedtext = ace.current.editor.getSelectedText();

    ace.current.editor.session.replace(
        selectedrange,
        "\\pagestyle{" + selectedtext + "}"
    );
};
const thispagestyle  = (ace) => {
    var selectedrange = ace.current.editor.getSelectionRange();
    let selectedtext = ace.current.editor.getSelectedText();

    ace.current.editor.session.replace(
        selectedrange,
        "\\thispagestyle{"+selectedtext+"}"
    );
};










const enlargethispage = (ace) => {
    var selectedrange = ace.current.editor.getSelectionRange();
    let selectedtext = ace.current.editor.getSelectedText();
    ace.current.editor.session.replace(
        selectedrange,
        "\\enlargethispage{" + selectedtext + "}"
    );
}
const toLowerCase = (ace) => {
    var selectedrange = ace.current.editor.getSelectionRange();
    let selectedtext = ace.current.editor.getSelectedText();
    console.log("changing the text to lower case is working")
    ace.current.editor.session.replace(
        selectedrange,
        selectedtext.toLowerCase()
    );
};

const noBreak = (ace) => {
    var selectedrange = ace.current.editor.getSelectionRange();
    let selectedtext = ace.current.editor.getSelectedText();
    ace.current.editor.session.replace(
        selectedrange,
        `\\nobreak{${selectedtext}}`
    );
};
const hBox = (ace) => {
    var selectedrange = ace.current.editor.getSelectionRange();
    let selectedtext = ace.current.editor.getSelectedText();
    ace.current.editor.session.replace(
        selectedrange,
        `\\hbox{${selectedtext}}`
    );
};
const toTextCase = (ace) => {
    var selectedRange = ace.current.editor.getSelectionRange();
    let selectedText = ace.current.editor.getSelectedText();
    let result = selectedText;
    if (!selectedText || typeof selectedText !== "string") return;
    try {
        const notToChange = ["are", "in", "at", "of", "is", "and", "or", "but", "nor", "for", "so", "yet"];
        const words = selectedText.split(" ");
        console.log("alt z is triggered")

        if (words.length === 1) {
            result = words[0][0].toUpperCase() + words[0].slice(1).toLowerCase();
        } else {
            result = words
                .map((item, i) => {
                    if (i === 0) {
                        return item[0].toUpperCase() + item.slice(1).toLowerCase();
                    } else {
                        return notToChange.includes(item.toLowerCase())
                            ? item
                            : item[0].toUpperCase() + item.slice(1).toLowerCase();
                    }
                })
                .join(" ");
        }


        ace.current.editor.session.replace(selectedRange, result);
    } catch (error) {
        console.log("error in using alt+z", error)
    }
};



// const envi = (ace) => {
//     var selectedrange = ace.current.editor.getSelectionRange();
//     let selectedtext = ace.current.editor.getSelectedText();
//     ace.current.editor.session.replace(
//         selectedrange,
//         `\\begin{}}`
//     );
// };




const customshortcuts = (num, ace) => {
    let current = JSON.parse(localStorage.getItem("shortcuts"));

    var cursorPosition = ace.current.editor.getCursorPosition();
    if (num === 1) {
        ace.current.editor.session.insert(cursorPosition, current.shortcut1);
    } else if (num === 2) {
        ace.current.editor.session.insert(cursorPosition, current.shortcut2);
    } else if (num === 3) {
        ace.current.editor.session.insert(cursorPosition, current.shortcut3);
    } else if (num === 4) {
        ace.current.editor.session.insert(cursorPosition, current.shortcut4);
    } else if (num === 5) {
        ace.current.editor.session.insert(cursorPosition, current.shortcut5);
    } else if (num === 6) {
        ace.current.editor.session.insert(cursorPosition, current.shortcut6);
    } else if (num === 7) {
        ace.current.editor.session.insert(cursorPosition, current.shortcut7);
    }
    return true;
};


export {
    textToBold,
    textToItalics,
    toLowerCase,
    noBreak,
    hBox,
    customshortcuts,
    toTextCase,
    enlargethispage,
    hbox,
    allowdisplaybreaks,
    clearpage,
    pagebreak,
    Query,
    AQ,
    hspace,
    vspace,
    midrule,
    cmidrule,
    chaptermark,
    setcounter,
    setconter,
    pagestyle,
    thispagestyle
}